const TIMEOUT_MEGAMENU = 150;
const MOBILE_BREAKPOINT = 1024;

/**
 * The HTML element for megamenu containing megamenu items
 */
class Megamenu extends HTMLElement {
    constructor() {
        super();

        this.megamenuEl = this;
        this.sectionHeader = document.querySelector('#shopify-section-header');
        this.mainNavigation = document.querySelector(this.getAttribute('navigation-main'));
        this.mainHeader = document.querySelector(this.getAttribute('header-main'));
        this.submenus = this.querySelectorAll('.megamenu-submenu');

        if(this.mainNavigation === null || this.mainHeader === null) {
            throw new Error('Main navigation or/and main header are undefined');
        }

        this.mobileBreakpoint = MOBILE_BREAKPOINT;

        /* Handle hover on main navigation item */
        this.mainNavigationItems = this.mainNavigation.querySelectorAll('a');

        // Media Queries
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;

        if (this.mainNavigationItems.length > 0 && !this.isMobile) {
            this.getSubmenuMaxHeight(100);
            this.bindEvents();
        }
    }

    bindEvents() {
        for (let i = 0; i < this.mainNavigationItems.length; i++) {
            this.mainNavigationItems[i].addEventListener('mouseenter', (e) => {
                this.megamenuEnterTimeout = setTimeout(() => {
                    this.mainNavigationMouseenterHandler(this.mainNavigationItems[i])
                },TIMEOUT_MEGAMENU);
            });
            this.mainNavigationItems[i].addEventListener('mouseleave', () => {
                clearTimeout(this.megamenuEnterTimeout);
            });
        }

        /* Global mouse over to determine when we should start timeout function and hide megamenu */
        document.addEventListener('mouseover', (e) => {
            if(e.target.closest('#shopify-section-header') || e.target.closest('#shopify-section-megamenu')) {
                clearTimeout(this.megamenuTimeout);
            } else {
                this.startTimeout();
            }
        })
    }

    startTimeout() {
        this.megamenuTimeout = setTimeout(() => {
            this.mainHeader.classList.remove('header--megamenu-active');
            document.body.classList.remove('megamenu-visible');
            this.hideMegamenu();
            this.hideSubmenus();
        }, TIMEOUT_MEGAMENU);
    }

    mainNavigationMouseenterHandler(element) {

        /* find target */
        const target = element.dataset.tabHandle;
        const submenuTarget = this.querySelector('[data-tab-handle="'+target+'"]');

        /* set current tab */
        this.currentTab = target;

        /* add class to current tab for styling pruposes */
        this.setActiveTabOnMainHeader();

        /* if has submenu */
        if(submenuTarget) {
            clearTimeout(this.megamenuTimeout);

            /* if submenu has been found, hide all precedent submenus and set header to opaque (white version) */
            this.hideSubmenus();

            /* also set main-header element to active for coloring main navigation items */
            this.mainHeader.classList.add('header--megamenu-active');

            document.body.classList.add('megamenu-visible');

            /* find and set height */
            // const mainHeaderBoundingRect = this.mainHeader.getBoundingClientRect();

            // this.style.top = (mainHeaderBoundingRect.height + mainHeaderBoundingRect.y) + 'px';

            /* show the whole megamenu */
            this.classList.add('megamenu-items--visible');
            /* show the target submenu */
            submenuTarget.classList.add('megamenu-submenu--visible');
        } else {
            this.startTimeout();
        }
    }

    hideMegamenu() {
        this.classList.remove('megamenu-items--visible');
    }

    hideSubmenus() {
        for (let i = 0; i < this.submenus.length; i++) {
            this.submenus[i].classList.remove('megamenu-submenu--visible');
        }
    }

    setActiveTabOnMainHeader() {
        const mainNavigationItems = this.mainNavigation.querySelectorAll('a');
        for (let i = 0; i < mainNavigationItems.length; i++) {
            mainNavigationItems[i].classList.remove('navigation-header__link--active');
        }

        this.mainNavigation.querySelector('[data-tab-handle="'+this.currentTab+'"]').classList.add('navigation-header__link--active');
    }

    getSubmenuMaxHeight(extraHeight = 0) {
        let maxHeight = 0;
        this.submenus.forEach(submenu => {
            maxHeight = Math.max(maxHeight, submenu.offsetHeight);
        });
        this.megamenuEl.style.setProperty('--submenu-max-height', `${maxHeight+extraHeight}px`);
    }
}

customElements.define('w3-megamenu', Megamenu);

